import { render, staticRenderFns } from "./renewalRateConfigModal.vue?vue&type=template&id=5e8d1d66&scoped=true"
import script from "./renewalRateConfigModal.vue?vue&type=script&lang=js"
export * from "./renewalRateConfigModal.vue?vue&type=script&lang=js"
import style0 from "./renewalRateConfigModal.vue?vue&type=style&index=0&id=5e8d1d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d1d66",
  null
  
)

export default component.exports